// extracted by mini-css-extract-plugin
export var messageSideLeft = "_n4-1";
export var messageSideRight = "_n4-2";
export var subscribeToBackInStockBubbleContainer = "_n4-0";